import { render } from "./add-organization.vue?vue&type=template&id=bbfc7aee"
import script from "./add-organization.vue?vue&type=script&lang=js"
export * from "./add-organization.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__